'use client';

import { useMemo } from 'react';
import { slotsToMsNum } from '@velocity-exchange/sdk';
import { useCurrentSlot } from 'src/hooks/useCurrentSlot';
import { useRiskCeilingSlotClock } from 'src/hooks/useSlotClock';
import { RelativeDateDisplay } from 'src/components/Tables/RelativeDateDisplay';
import { AccountOrder } from '../types';

interface TimeCellProps {
	order: AccountOrder;
	displayAsTimestamp: boolean;
}

export function TimeCell({ order, displayAsTimestamp }: TimeCellProps) {
	const currentSlot = useCurrentSlot();
	// An age readout: overstating age is the safe direction, so it falls back to
	// the longest slot rather than making an order look fresher than it is.
	const { slotDurationMs } = useRiskCeilingSlotClock();

	const orderTime = useMemo(() => {
		if (order.ts) return new Date(order.ts.toNumber() * 1000);
		const slotDiff = currentSlot - order.slot.toNumber();
		if (slotDiff < 0) return new Date();
		const estimatedMsAgo = slotsToMsNum(slotDiff, slotDurationMs);
		return new Date(Date.now() - estimatedMsAgo);
	}, [order.slot, order.ts, currentSlot, slotDurationMs]);

	return (
		<RelativeDateDisplay
			date={orderTime}
			displayAsTimestamp={displayAsTimestamp}
		/>
	);
}
